<template>
  <section class="overflow-hidden">
    <WarrantyHeroSection
      :title="$t('common.warranty.bikes')"
      :secondaryTitle="$t('common.warranty.warranty')"
      :description="
        $t('common.warranty.bbike_hero_description', {
          brand_name: 'Benelli Bike',
          country: defaultContryName,
          interpolation: { prefix: '[:', suffix: ']' },
        })
      "
      imageUrl="distributor"
    />
    <WarrantyValidity />
    <WarrantyCondition />
    <WarrantyShimano />
    <WarrantyRequest />
    <WarrantyRecommendations />
    <WarrantyRegistration />
    <WarrantyAnnex />
  </section>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
import { useMainStore } from "~/store";
import { useWarrantyStore } from "~/store/warranty";

const { t } = useTranslation();
const store = useMainStore();
const warrantyStore = useWarrantyStore();
const title = ref(t("common.warranty"));
const content = ref(null);
const faultyParts = ref([null]);

try {
  warrantyStore.fetchFaultyParts();
} catch (e) {
  console.error(e);
}
// try {
//   const { data } = await useAPI("api/front/pages/warranty");
//   if (data._rawValue.data) {
//     content.value = data._rawValue.data.content;
//     title.value = data._rawValue.data.title;
//   }
// } catch (e) {
//   error({ statusCode: 404 });
// }

useNuxtApp().$seoModule({
  title: title.value,
  meta_name: title.value,
  meta_description: title.value,
  og_name: title.value,
  og_description: title.value,
  model_id: "warranty",
  model_type: "FrontendPage",
});
</script>
